module.exports = __webpack_public_path__ + "static/media/beak-down.88f2ab69.svg";